var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("basicData.CustomVersion"),
        visible: _vm.dialogVisible,
        width: "600px",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": true,
        "show-close": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "dialog-content" }, [
        _c(
          "div",
          { staticClass: "version-select" },
          [
            _c("span", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t("basicData.VersionSelection"))),
            ]),
            _c(
              "el-radio-group",
              {
                staticClass: "radio-group",
                model: {
                  value: _vm.versionType,
                  callback: function ($$v) {
                    _vm.versionType = $$v
                  },
                  expression: "versionType",
                },
              },
              [
                _c("el-radio", { attrs: { label: 1 } }, [
                  _vm._v(_vm._s(_vm.$t("basicData.LatestVersion"))),
                ]),
                _c(
                  "el-radio",
                  { attrs: { disabled: !_vm.isDisable, label: 2 } },
                  [_vm._v(_vm._s(_vm.$t("basicData.CustomVersion")))]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c("div", { staticClass: "tip-box" }, [
          _c("i", { staticClass: "el-icon-warning tip-icon" }),
          _c("div", { staticClass: "tip-content" }, [
            _c("p", [
              _c("strong", [
                _vm._v(_vm._s(_vm.$t("basicData.LatestVersion")) + "："),
              ]),
              _vm._v(
                _vm._s(
                  _vm.$t("basicData.RecalculateUsingLatestEffectivePricing")
                )
              ),
            ]),
            _c("p", [
              _c("strong", [
                _vm._v(_vm._s(_vm.$t("basicData.CustomVersion")) + "："),
              ]),
              _vm._v(
                _vm._s(_vm.$t("basicData.RecalculateWithSelectedPricing"))
              ),
            ]),
          ]),
        ]),
      ]),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.handleCancel } },
            [_vm._v(_vm._s(_vm.$t("basicData.Cancel")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.handleConfirm },
            },
            [_vm._v(_vm._s(_vm.$t("basicData.determine")))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }